import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faFlag } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import auth from '../auth/auth';

const CommentManagement = () => {
  const [comments, setComments] = useState([]);
  const [flaggedUsers, setFlaggedUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [flagReason, setFlagReason] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API}/commentaires`, { headers: auth() })
      .then((res) => {
        setComments(res.data);
      })
      .catch((error) => {
        console.log('Error lors de la récupération');
      });
  }, []);

  const handleDelete = async (commentId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API}/supprimer-commentaire/${commentId}`, { headers: auth() });
      console.log('Commentaire bien supprimer.');
      setComments((prevComments) => prevComments.filter((comment) => comment._id !== commentId));
    } catch (error) {
      console.log('Erreur lors de la supression du commentaire');
    }
  };

  const handleFlag = (commentId) => {
    setSelectedUserId(commentId);

    const reason = prompt('Veuillez entrer le motif de signalement :');
    if (reason) {
      setFlagReason(reason);

      const selectedComment = comments.find((comment) => comment._id === commentId);

      if (selectedComment) {
        setFlaggedUsers((prevFlaggedUsers) => [
          ...prevFlaggedUsers,
          {
            userId: commentId,
            author: selectedComment.author || '',
            text: selectedComment.text || '',
            reason,
          },
        ]);
      }

      setSelectedUserId(null);
      setFlagReason('');
    }
  };

  return (
    <main>
      <section>
        <h2 className='heading'>Management des commentaires</h2>
        <h3>Nombre total de commentaires : {comments.length}</h3>
        <table className="comment-table">
          <thead>
            <tr>
              <th className="comment-id">L'Id du commentaire</th>
              <th className="comment-author">L'auteur</th>
              <th className="comment-message">Le message</th>
              <th className="comment-actions">Action(s)</th>
            </tr>
          </thead>
          <tbody>
            {comments.map((comment) => (
              <tr key={comment._id}>
                <td>{comment._id}</td>
                <td>{comment.author}</td>
                <td>{comment.text}</td>
                <td>
                  <button className="delete-button" onClick={() => handleDelete(comment._id)}>
                    <FontAwesomeIcon icon={faTrash} className="trash-icon" />
                  </button>
                  <button className="flag-button" onClick={() => handleFlag(comment._id)}>
                    <FontAwesomeIcon icon={faFlag} className="flag-icon" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <section>
        <h2 className='heading'>Commentaires Signalés</h2>
        <h3>Nombre d'utilisateurs signalés : {flaggedUsers.length}</h3>
        <table className="user-table">
          <thead>
            <tr>
              <th className="user-id">L'Id de l'utilisateur</th>
              <th className="user-login">L'auteur</th>
              <th className="user-email">Le message</th>
              <th className="user-actions">Raison</th>
            </tr>
          </thead>
          <tbody>
            {flaggedUsers.map((flaggedUser) => (
              <tr key={flaggedUser.userId}>
                <td>{flaggedUser.userId}</td>
                <td>{flaggedUser.author}</td>
                <td>{flaggedUser.text}</td>
                <td>{flaggedUser.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </main>
  );
};

export default CommentManagement;
